import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Group, Loader, useMantineTheme } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { isoDateToSqlDate } from "../../utils/globalFunctions";

import PickerDate from "../../components/general/PickerDate";
import LabelWithAsterisk from "../general/LabelWithAsterisk";
import ModalResponse from "../../components/general/ModalResponse";

const TanggalMasukProject = ({ stateData, fnOnChange }) => {

    const mountedRef = React.useRef(true);
    const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'tanggalMasukProject-1',
    })

    const [data, setData] = React.useState({
        submitLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitData = (value) => {
        setData(d => ({
            ...d,
            submitLoading: true,
        }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);
        formDT.append('project_tanggal_nota', isoDateToSqlDate(value, ''));

        axios({
            method: 'post',
            url: BE_API_TWO + '/edit_project_tanggal_masuk',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submitLoading: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChange(value);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                submitLoading: false
            }))

            notifications.show({
                id: notificationId.current.errorSubmitData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <PickerDate
                stateMinDate={null}
                stateDate={stateData.data.value}
                stateVariant="default"
                // stateIconSX={{ width: 'unset', color: theme.colors.blue[6] }}

                stateStylesInput={{
                    backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7]
                }}

                fnSetDate={(val) => submitData(val)}

                stateLabel={
                    <Group>
                        <LabelWithAsterisk stateLabel={stateData.data.label} />
                        {data.submitLoading && <Loader size="xs" />}
                    </Group>
                }
                statePlaceHolder={stateData.data.placeholder}
                // stateWithAsterisk={stateData.data.withAsterisk}
                stateWithAsterisk={false}
                stateDescription={stateData.data.description}
                stateError={stateData.data.error}
            />

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default TanggalMasukProject;